module.exports = __webpack_public_path__ + "static/SplendaRetouch1-ccfdcdaf848fa7f81a75e318e53cfa9f.jpg";